import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabaseService } from './database.service';

@Pipe({
  name: 'getimage',
})
export class getimagepipe implements PipeTransform {

  constructor(private databaseservice: DatabaseService, private _sanitizer: DomSanitizer) {

  }
  imagepath: any;
  transform(value: string) : any {
    
    this.databaseservice.GetImage('payroll.jpg').subscribe(res => {
      if (res.type != 'text/plain') {
        let objectURL = 'data:image/jpeg;base64,' + res.image;
       // console.log(this._sanitizer.bypassSecurityTrustUrl(objectURL));
        return this._sanitizer.bypassSecurityTrustUrl(objectURL);
      }     
    }, error => { });
   
  }
}
